<template>
  <div class="dealer" v-if="sessionStorageSet">
    <span class="back">‹</span>
    <a :href="url_redirect_to_dealer">{{ label_back_to }} {{ label_company_name }}</a>
    <img height="45" :src="logo_src" alt />
  </div>
</template>
<script>
export default {
  props: {
    sskey: {
      type: String,
      default: null
    },
    url_redirect_to_dealer: {
      type: String,
      required: true
    },
    label_back_to: {
      type: String,
      required: true
    },
    label_company_name: {
      type: String,
      required: true
    },
    logo_src: {
      type: String,
      required: true
    }
  },
  computed: {},
  mounted() {
    let len = sessionStorage.getItem(this.sskey)
      ? sessionStorage.getItem(this.sskey).length
      : 0;
    this.sessionStorageSet = len > 0 ? true : false;

    if(!this.sessionStorageSet){
       this.destroySession();
    }    
  },
  data() {
    return {
      sessionStorageSet: false
    };
  },
  methods: {
    destroySession(){
      setTimeout(() => {
        axios.post(`/` + window.culture + `/api/dealer-session-tear`)
          .then(function (response){
            if (response.data.data && response.data.success === true) {
              window.location.href = "/"+window.culture;  
            }
          });
      }, 500)
    }

  }
};
</script>
